module.exports = __webpack_public_path__ + "img/vector-bg-10.957855ad.svg";